<template>
  <div class="home-view">  
    <transition name="el-fade-in-linear">
      <loginView v-show="loginViewIsShow"></loginView>
    </transition>
  </div>
</template>

<script> 
import loginView from '@/components/loginView/loginView.vue'  
import { getUserInfo } from "@/api/lxc/index.js" 
export default {
  name: "home",
  data() {
    return { 
      loginViewIsShow:true
    };
  },
  components:{
    loginView
  },
  computed: { 
    
  },
  watch:{ 
  },
  methods: { 
  },
  mounted(){
      // getUserInfo().then((res)=>{  
      //   if(res.code === 0 && res.type === "unit" ){
      //     this.$store.commit("setUserInfo",res.user)
      //     this.$router.replace("bookList") 
      //   } else{
      //     this.$store.commit("setUserInfo",res.user)
      //     this.$router.replace("bookList") 
      //   }
      // }) 
  }
};
</script>

<style scoped lang="less">
@import "./home.less";
</style>
